export default {
  "01M": "Chemicals",
  "01R": "Agriculture",
  "02M": "Electronics",
  "02R": "Energy resources",
  "03M": "Food & beverages",
  "03R": "Minerals",
  "04M": "Machinery",
  "05M": "Medical & scientific instruments",
  "06M": "Metal products",
  "07M": "Non-metallic mineral products",
  "08M": "Others",
  "09M": "Pharmaceutical products",
  "0A1": "Agriculture",
  "0A10": "Non-metallic mineral products",
  "0A11": "Others",
  "0A12": "Pharmaceutical products",
  "0A13": "Rubber & plastic products",
  "0A14": "Textiles",
  "0A15": "Transport equipment",
  "0A16": "Wood & paper products",
  "0A2": "Chemicals",
  "0A3": "Electronics",
  "0A4": "Energy resources",
  "0A5": "Food & beverages",
  "0A6": "Machinery",
  "0A7": "Medical & scientific instruments",
  "0A8": "Metal products",
  "0A9": "Minerals",
  "10M": "Rubber & plastic products",
  "11M": "Textiles",
  "12M": "Transport equipment",
  "13M": "Wood & paper products",
  M01: "Dyes, pigments, coatings",
  M02: "Fertilizers",
  M03: "Fibers",
  M04: "Inorganic chemicals",
  M05: "Organic intermediates",
  M06: "Other",
  M07: "Pesticides",
  M08: "Polymers & plastics",
  M09: "Synthetic rubber",
  M10: "Cosmetics & personal care chemicals",
  M11: "Telephone sets",
  M12: "Components - chips",
  M13: "Computers",
  M14: "Components - other",
  M15: "Electric household appliances",
  M16: "Media equipment",
  M17: "Other",
  M18: "Meat & seafood products",
  M19: "Dairy products",
  M20: "Other",
  M21: "Vegetable, fruit & nut products",
  M22: "Animal or vegetable fats & oils",
  M23: "Sugar & cacao products",
  M24: "Pasta & baked goods",
  M25: "Beverages",
  M26: "Tobacco",
  M27: "Power generation & transmission (machinery & components)",
  M28: "Mining, construction, industrial (machinery & components)",
  M29: "Mechanical household appliances",
  M30: "Basic components",
  M31: "Textile production (machinery & components)",
  M32: "Printing (machinery & components)",
  M33: "Chip production (machinery & components)",
  M34: "General use machinery",
  M35: "Packaging (machinery & components)",
  M36: "Metal processing (machinery & components)",
  M37: "Non-metal processing (machinery & components)",
  M38: "Food processing (machinery & components)",
  M39: "Agriculture & forestry (machinery & components)",
  M40: "Material-handling (machinery & components)",
  M41: "Paper production (machinery & components)",
  M42: "Other",
  M43: "Medical instruments",
  M44: "Scientific instruments",
  M45: "Gold",
  M46: "Copper",
  M47: "Iron & steel",
  M48: "Other",
  M49: "Aluminium",
  M50: "Silver",
  M51: "Nickel",
  M52: "Zinc",
  M53: "Lead",
  M54: "Cement products",
  M55: "Other",
  M56: "Ceramic products",
  M57: "Glass products",
  M58: "Retail chemicals",
  M59: "Prefabricated buildings",
  M60: "Cork",
  M61: "Straw",
  M62: "Clocks & watches",
  M63: "Miscellaneous manufactured items",
  M64: "Umbrellas, sticks, whips, riding-crops",
  M65: "Artificial flowers",
  M66: "Items made of feather, down or hair",
  M67: "Pearls & precious stones",
  M68: "Arms & ammunition",
  M69: "Optical equipment (not electronic in nature)",
  M70: "Musical instruments",
  M71: "Furniture & mattresses",
  M72: "Toys, games, sport equipment",
  M73: "Art & antiques",
  M74: "Not specified",
  M75: "Small molecules",
  M76: "Biologics",
  M77: "Vaccines",
  M78: "Other",
  M79: "Plastic products",
  M80: "Rubber products",
  M81: "Footwear",
  M82: "Circular and flatknit apparel & accessories",
  M83: "Woven apparel & accessories",
  M84: "Leather apparel & accessories",
  M85: "Fabrics, yarns, fibres - circular & flatknit",
  M86: "Fabrics, yarns, fibres - woven",
  M87: "Other",
  M88: "Headgear",
  M89: "Fabrics, yarns, fibres - leather",
  M90: "Home textile products",
  M91: "Aircraft & parts",
  M92: "Ships & parts",
  M93: "Road vehicle parts",
  M94: "General parts",
  M95: "Rolling stock & parts",
  M96: "Road vehicles (excl. passenger vehicles)",
  M97: "Passenger vehicles",
  M98: "Other",
  MA1: "Wood products",
  MA2: "Paper products",
  R01: "Animals (incl. primary processed aquatic animals)",
  R02: "Other",
  R03: "Vegetables",
  R04: "Fruit & nuts",
  R05: "Wheat",
  R06: "Corn",
  R07: "Rice",
  R08: "Other grains & oilseeds",
  R09: "Soybeans",
  R10: "Coal",
  R11: "Crude oil",
  R12: "Refined petroleum products",
  R13: "Liquefied natural gas",
  R14: "Natural gas liquids",
  R15: "Pipeline natural gas",
  R16: "Electrical energy",
  R17: "Iron ore",
  R18: "Copper ore",
  R19: "Zinc ore",
  R20: "Lead ore",
  R21: "Silver ore",
  R22: "Gold ore",
  R23: "Nickel ore",
  R24: "Aluminium ore",
  R25: "Other",
  T10M: "Total",
  T11M: "Total",
  T12M: "Total",
  T13M: "Total",
  T1M: "Total",
  T1R: "Total",
  T2M: "Total",
  T2R: "Total",
  T3M: "Total",
  T3R: "Total",
  T4M: "Total",
  T5M: "Total",
  T6M: "Total",
  T7M: "Total",
  T8M: "Total",
  T9M: "Total",
  TAG: "Total",
  TMT: "Total",
  TRT: "Total",
} as const;
